import { authTypes } from "./auth.types";

export const setIsLoggedInUser = (isLoggedInUser) => ({
  type: authTypes.SET_IS_LOGGED_IN_USER,
  payload: isLoggedInUser,
});

export const setLoginLoading = (isLoading) => ({
  type: authTypes.SET_LOGIN_LOADING,
  payload: isLoading,
});

export const setResetPassLoading = (isLoading) => ({
  type: authTypes.SET_RESET_PASSWORD_lOADING,
  payload: isLoading,
});
